const system =
{
  // 基础后台接口链接
  // baseApiUrl: 'http://192.168.200.245:18370',
  // businessApplication:'http://192.168.200.245:304/businessSystem/indexAdminLogin', // 业务应用
  // standardService:'http://192.168.200.245:304/cmsSystem/indexAdminLogin', // 标准服务
  // internetOfThings:'http://192.168.200.245:304/iotSystem/indexAdminLogin', // 物联网
  // memberServices:'http://192.168.200.245:304/memberSystem/indexAdminLogin', // 会员服务
  // bigDataAnalysis: '', // 大数据分析
  // dataExchange: 'http://192.168.200.245:304/dataExchangeSystem/indexAdminLogin',  // 数据交换
  // basicData:'http://192.168.200.245:304/baseSystem/indexAdminLogin', // 基础数据
  // unifiedIdentityAuthentication:'http://192.168.200.245:304/adminUserSystem/indexAdminLogin', // 统一身份认证
  // systemSettings:'http://192.168.200.245:304/setSystem/indexAdminLogin' // 系统设置

  baseApiUrl: 'http://111.30.78.202:8081',
  businessApplication:'http://111.30.78.202:8085/businessSystem/indexAdminLogin', // 业务应用
  standardService:'http://111.30.78.202:8085/cmsSystem/indexAdminLogin', // 标准服务
  internetOfThings:'http://111.30.78.202:8085/iotSystem/indexAdminLogin', // 物联网
  memberServices:'http://111.30.78.202:8085/memberSystem/indexAdminLogin', // 会员服务
  bigDataAnalysis: 'http://111.30.78.202:8112/foodSafetySituation', // 大数据分析
  dataExchange: 'http://111.30.78.202:8085/dataExchangeSystem/indexAdminLogin',  // 数据交换
  basicData:'http://111.30.78.202:8085/baseSystem/indexAdminLogin', // 基础数据
  unifiedIdentityAuthentication:'http://111.30.78.202:8085/adminUserSystem/indexAdminLogin', // 统一身份认证
  systemSettings:'http://111.30.78.202:8085/setSystem/indexAdminLogin' // 系统设置



  // baseApiUrl: 'http://116.198.150.253:8070',
  // businessApplication:'http://116.198.150.253:85/indexAdminLogin', // 业务应用
  // standardService:'http://116.198.150.253:81/indexAdminLogin', // 标准服务
  // internetOfThings:'http://116.198.150.253:88/indexAdminLogin', // 物联网
  // memberServices:'http://116.198.150.253:86/indexAdminLogin', // 会员服务
  // bigDataAnalysis: '', // 大数据分析
  // dataExchange: '',  // 数据交换
  // basicData:'http://116.198.150.253:84/indexAdminLogin', // 基础数据
  // unifiedIdentityAuthentication:'http://116.198.150.253:83/indexAdminLogin', // 统一身份认证
  // systemSettings:'http://116.198.150.253:82/indexAdminLogin' // 系统设置

  // 基础后台接口链接
  // baseApiUrl: 'http://api.720.weetion.com',
  // businessApplication:'http://business.720.weetion.com/indexAdminLogin', // 业务应用
  // standardService:'http://standard.720.weetion.com/indexAdminLogin', // 标准服务
  // internetOfThings:'http://iot.720.weetion.com/indexAdminLogin', // 物联网
  // memberServices:'http://member.720.weetion.com/indexAdminLogin', // 会员服务
  // bigDataAnalysis: '', // 大数据分析
  // dataExchange: '',  // 数据交换
  // basicData:'http://basedata.720.weetion.com/indexAdminLogin', // 基础数据
  // unifiedIdentityAuthentication:'http://user.720.weetion.com/indexAdminLogin', // 统一身份认证
  // systemSettings:'http://settion.720.weetion.com/indexAdminLogin' // 系统设置

  // 基础后台接口链接
  // baseApiUrl: 'http://api.test.720.weetion.com',
  // businessApplication:'http://business.test.720.weetion.com/indexAdminLogin', // 业务应用
  // standardService:'http://standard.test.720.weetion.com/indexAdminLogin', // 标准服务
  // internetOfThings:'http://iot.test.720.weetion.com/indexAdminLogin', // 物联网
  // memberServices:'http://member.test.720.weetion.com/indexAdminLogin', // 会员服务
  // bigDataAnalysis: '', // 大数据分析
  // dataExchange: '',  // 数据交换
  // basicData:'http://basedata.test.720.weetion.com/indexAdminLogin', // 基础数据
  // unifiedIdentityAuthentication:'http://user.test.720.weetion.com/indexAdminLogin', // 统一身份认证
  // systemSettings:'http://settion.test.720.weetion.com/indexAdminLogin' // 系统设置
}

export default system

